import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../../../../core/h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-annotation-panel',
  templateUrl: './annotation-panel.component.html',
  styleUrl: './annotation-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnnotationPanelComponent extends DirectiveSuperclass {
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);

  isClassSelectorOpen$ = this.taskWorkspaceStore('sidePanel')(
    'annotationPanelState',
  ).$.pipe(map((state) => state === 'class_selector'));
}
